export default {
  pl: {
    0: {
      full: 'styczeń',
      short: 'sty',
      genitive: 'stycznia',
    },
    1: {
      full: 'luty',
      short: 'lut',
      genitive: 'lutego'
    },
    2: {
      full: 'marzec',
      short: 'mar',
      genitive: 'marca'
    },
    3: {
      full: 'kwiecień',
      short: 'kwie',
      genitive: 'kwietnia'
    },
    4: {
      full: 'maj',
      short: 'maj',
      genitive: 'maja'
    },
    5: {
      full: 'czerwiec',
      short: 'czer',
      genitive: 'czerwca'
    },
    6: {
      full: 'lipiec',
      short: 'lip',
      genitive: 'lipca'
    },
    7: {
      full: 'sierpień',
      short: 'sier',
      genitive: 'sierpnia'
    },
    8: {
      full: 'wrzesień',
      short: 'wrze',
      genitive: 'września'
    },
    9: {
      full: 'październik',
      short: 'paź',
      genitive: 'października'
    },
    10: {
      full: 'listopad',
      short: 'list',
      genitive: 'listopada'
    },
    11: {
      full: 'grudzień',
      short: 'gru',
      genitive: 'grudnia'
    }
  },
  en: {
    0: {
      full: 'january',
      short: 'jan',
      genitive: 'january',
    },
    1: {
      full: 'february',
      short: 'feb',
      genitive: 'february'
    },
    2: {
      full: 'march',
      short: 'mar',
      genitive: 'march'
    },
    3: {
      full: 'april',
      short: 'apr',
      genitive: 'april'
    },
    4: {
      full: 'may',
      short: 'may',
      genitive: 'may'
    },
    5: {
      full: 'june',
      short: 'jun',
      genitive: 'june'
    },
    6: {
      full: 'july',
      short: 'jul',
      genitive: 'july'
    },
    7: {
      full: 'august',
      short: 'aug',
      genitive: 'august'
    },
    8: {
      full: 'september',
      short: 'sep',
      genitive: 'september'
    },
    9: {
      full: 'october',
      short: 'oct',
      genitive: 'october'
    },
    10: {
      full: 'november',
      short: 'nov',
      genitive: 'november'
    },
    11: {
      full: 'december',
      short: 'dec',
      genitive: 'december'
    }
  }
};
